import React, { createContext, useReducer } from "react";

export const BlendAppQuizzDataContext = createContext([]);

export const BlendAppQuizzDataContextProvider = (props) => {
    const [blendAppQuizzData, dispatchToBlendAppQuizzData] = useReducer(
        (state, action) => {
            switch (action.type) {
                case "ADD_ANSWER":
                    const foundIndex = state.findIndex(
                        (item) => item.questionId === action.payload.questionId
                    );
                    if (foundIndex === -1) return [...state, action.payload];
                    state[foundIndex].answerId = action.payload.answerId;
                    return state;
                case "RESET_ANSWERS":
                    return [];
                default:
                    throw new Error();
            }
        },
        []
    );

    return (
        <BlendAppQuizzDataContext.Provider
            value={[blendAppQuizzData, dispatchToBlendAppQuizzData]}
        >
            {props.children}
        </BlendAppQuizzDataContext.Provider>
    );
};
